<template>
  <portlet
      v-bind:class="showAnimation ? 'highlight-portlet' : ''"
      :actionsBlock="false"
      :icon="'fal fa-user-edit'"
      :title="getFormTitle"
  >
    <template slot="portletBody">
      <div class="teams-form">
        <div class="row">
          <div class="col-12 col-md-9 col-lg-7 col-xl-6">
            <div class="form-group">
              <label for="team-name">{{ $t('teams.name') }}</label>
              <input type="text" v-validate="'required'" v-model="editingTeam.name" class="form-control"
                     id="team-name">
            </div>
          </div>
          <div class="col-12 col-md">
            <div class="form-group">
              <label for="team-name">{{ $t('teams.code') }}</label>
              <input type="text" v-validate="'required'" v-model="editingTeam.code" class="form-control"
                     id="team-code">
            </div>
          </div>
          <div class="col-12">
            <label>{{ $t('menu.workflows') }}</label>
            <div  class="row">
              <div v-for="(workflow, index) of getWorkflows" :key="'workflow-option-'+index" class="workflow-id-option col-3">
                <div class="custom-control custom-checkbox">
                  <input
                         :value="workflow.id"
                         type="checkbox"
                         v-model="editingTeam.workflowIds" :true-value="[]"
                         :id="'wf' + index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="'wf' + index">
                    <span>{{ workflow.name }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row justify-content-end">
          <div class="col-12 col-sm-auto">
            <button id="dismiss-team-changes-button" @click="dismissTeamEdit()" class="mt-2 btn btn-primary">
              {{ $t('ui.cancel') }}
            </button>
          </div>
          <div class="col-12 col-sm-auto">
            <button id="save-team-button" @click="saveTeam()" class="mt-2 btn btn-primary">{{ $t('ui.save') }}</button>
          </div>
        </div>
      </div>
    </template>
  </portlet>
</template>

<script>
import {mapGetters} from "vuex";
import {teamFunctions} from "@/mixins/teams/teamsFunctions";
import SearchDropdown from "@/components/SearchDropdown";

export default {
  name: "TeamsForm",
  props: ['originalEditingTeam'],
  mixins: [teamFunctions],
  components: {
    SearchDropdown
  },
  data() {
    return {
      editingTeam: this.getEmptyTeam(),
      showAnimation: false
    }
  },
  computed: {
    ...mapGetters('users', [
      'getClaims'
    ]),
    ...mapGetters('workflows', [
      'getWorkflows'
    ]),
    getFormTitle() {
      return this.originalEditingTeam ? this.$t('teams.form.edit.title', {name: this.originalEditingTeam.name}) : this.$t('teams.form.create.title')
    }
  },
  methods: {
    async saveTeam() {
      const valid = await this.$validator.validateAll();
      console.log("VALID", valid, {...this.editingTeam, companyId: this.getClaims.companyId})

      if (valid) {
        if (this.editingTeam.id) {
          await this.$store.dispatch('teams/patch', {...this.editingTeam, companyId: this.getClaims.companyId});
        } else {
          await this.$store.dispatch('teams/set', {...this.editingTeam, companyId: this.getClaims.companyId});
        }

        this.dismissTeamEdit();
        this.$toasted.global.successRequest({
          message: this.$t('teams.form.saved')
        });
      } else {
        this.$toasted.global.failedFormRequest();
      }
    },
    dismissTeamEdit() {
      this.$validator.reset()
      this.editingTeam = this.getEmptyTeam();
      this.$emit('clearOriginalEditingTeam')
    },
    getEmptyTeam() {
      return {
        name: '',
        code: '',
        department: null,
        workflowIds: [],
        fakeTeam: false
      };
    }
  },
  watch: {
    originalEditingTeam: {
      handler(newV, oldV) {
        if (this.originalEditingTeam) {
          this.showAnimation = true;
          this.editingTeam = _.cloneDeep(this.originalEditingTeam);
          setTimeout(() => {
            this.showAnimation = false;
          }, 1000)
        } else {
          this.editingTeam = this.getEmptyTeam();
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
#save-team-button, #dismiss-team-changes-button, .select-department-dropdown {
  width: 100%;
}

.highlight-portlet {
  animation: fadeInDown; /* referring directly to the animation's @keyframe declaration */
  animation-duration: 1s; /* don't forget to set a duration! */
}
</style>